var m = require('mithril');
var _ = require('lodash');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

var editFieldsModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function buildUnitSuggestions(fieldDef, units) {
  var seen = {};
  return ontologyFields.getUnitsForKind(fieldDef.kind, units).reduce(function (options, unitRecord) {
    [unitRecord && unitRecord.name].concat(Array.isArray(unitRecord && unitRecord.aliases) ? unitRecord.aliases : [])
      .forEach(function (value) {
        var trimmed = String(value || '').trim();
        if (!trimmed || seen[trimmed]) return;
        seen[trimmed] = true;
        options.push(trimmed);
      });
    return options;
  }, []);
}

async function ensureUnitsLoaded() {
  if (Array.isArray(editFieldsModal.units) && editFieldsModal.units.length) {
    return editFieldsModal.units;
  }
  editFieldsModal.units = await loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/unit',
    method: 'GET',
    background: true
  });
  return editFieldsModal.units;
}

editFieldsModal.editDialogue = async function (equipmentRecord, equipmentFields, options) {
  editFieldsModal.equipmentRecord = equipmentRecord;
  editFieldsModal.equipmentFields = ontologyFields.normalizeFieldDefinitions(equipmentFields);
  editFieldsModal.fieldValues = {};

  editFieldsModal.equipmentFields.forEach(function (fieldDef) {
    var fieldName = ontologyFields.getFieldName(fieldDef);
    editFieldsModal.fieldValues[fieldName] = ontologyFields.getEditableFieldValue(equipmentRecord, fieldDef);
  });

  await ensureUnitsLoaded();

  var submit = function () {
    var body = {};
    editFieldsModal.equipmentFields.forEach(function (fieldDef) {
      var fieldName = ontologyFields.getFieldName(fieldDef);
      body[fieldName] = ontologyFields.buildFieldPayload(fieldDef, editFieldsModal.fieldValues[fieldName]);
    });

    return loaders.requestWithLoader({
      loader: 'main',
      url: '/api/v1/customequipment/' + equipmentRecord['@rid'].slice(1),
      method: 'PUT',
      body: body
    })
    .then(function () {
      key.unbind('enter');
      if (options && options.submitCallback) {
        options.submitCallback();
      }
      modal.vm.close();
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Edit ' + equipmentRecord.name + ': ');
  modal.vm.body = editFieldsModal.view;
  modal.vm.buttons([
    {
      label: 'Submit',
      class: 'btn-good',
      func: submit
    }
  ]);
  modal.vm.open();
};

function renderQuantityField(fieldDef) {
  var fieldName = ontologyFields.getFieldName(fieldDef);
  var value = editFieldsModal.fieldValues[fieldName] || { value: '', unit: fieldDef.defaultUnit || '' };
  var unitSuggestions = buildUnitSuggestions(fieldDef, editFieldsModal.units);
  var datalistId = 'equipment-field-unit-' + fieldName;

  return m('div.mb3', [
    m('label.db.mb1', _.startCase(fieldName) + ':'),
    m('div.flex.items-center', [
      m('input.form-control.mr2', {
        style: { flex: '1 1 auto' },
        type: 'number',
        step: 'any',
        value: value.value,
        oninput: function (ev) {
          editFieldsModal.fieldValues[fieldName] = {
            value: ev.target.value,
            unit: editFieldsModal.fieldValues[fieldName] && editFieldsModal.fieldValues[fieldName].unit
              ? editFieldsModal.fieldValues[fieldName].unit
              : (fieldDef.defaultUnit || '')
          };
        }
      }),
      m('input.form-control', {
        style: { flex: '0 0 10rem' },
        type: 'text',
        list: datalistId,
        value: value.unit || '',
        placeholder: fieldDef.defaultUnit || 'Unit',
        oninput: function (ev) {
          editFieldsModal.fieldValues[fieldName] = {
            value: editFieldsModal.fieldValues[fieldName] && typeof editFieldsModal.fieldValues[fieldName] === 'object'
              ? editFieldsModal.fieldValues[fieldName].value
              : '',
            unit: ev.target.value
          };
        }
      }),
      m('datalist', { id: datalistId }, unitSuggestions.map(function (unitName) {
        return m('option', { value: unitName });
      }))
    ]),
    m('div.f6.moon-gray.mt1', [
      fieldDef.kind ? ('Kind: ' + fieldDef.kind) : '',
      fieldDef.defaultUnit ? (' Default: ' + fieldDef.defaultUnit) : ''
    ])
  ]);
}

function renderTextField(fieldDef) {
  var fieldName = ontologyFields.getFieldName(fieldDef);
  return m('div.mb3', [
    m('label.db.mb1', _.startCase(fieldName) + ':'),
    m('input.form-control', {
      oninput: function (ev) {
        editFieldsModal.fieldValues[fieldName] = ev.target.value;
      },
      value: editFieldsModal.fieldValues[fieldName]
    })
  ]);
}

editFieldsModal.view = function () {
  return m('form', { role: 'form' }, [
    editFieldsModal.errorView(),
    editFieldsModal.equipmentFields.map(function (fieldDef) {
      if (ontologyFields.isQuantityField(fieldDef)) {
        return renderQuantityField(fieldDef);
      }
      return renderTextField(fieldDef);
    })
  ]);
};

module.exports = editFieldsModal;
